<script setup lang="ts">
const criteriaStore = useSearchCriteriaStore();
const fullLocale = useFullLocale();
</script>

<template>
  <span class="min-w-0 truncate text-xs font-normal tabular-nums text-text-inverse md:hidden">{{
    criteriaStore.committedDepartureDate
      ? formatDateShort(criteriaStore.committedDepartureDate, fullLocale) +
        (criteriaStore.committedReturnDate
          ? ` – ${formatDateShort(criteriaStore.committedReturnDate, fullLocale)}`
          : '')
      : ''
  }}</span>
  <span class="hidden whitespace-nowrap text-sm font-normal tabular-nums text-text-inverse md:inline">{{
    criteriaStore.committedDepartureDate
      ? formatDateLong(criteriaStore.committedDepartureDate, fullLocale) +
        (criteriaStore.committedReturnDate ? ` – ${formatDateLong(criteriaStore.committedReturnDate, fullLocale)}` : '')
      : ''
  }}</span>
</template>
